<main>
	<div class="login-form">
		<div *ngIf="!showTwoFactorStep">
			<div class="field">
				<label for="username">Username</label>
				<input pInputText type="text" [(ngModel)]="username" id="username" />
			</div>
			<div class="field">
				<label for="password">Password</label>
				<p-password [(ngModel)]="password" id="password" (keyup.enter)="login()" [feedback]="false" [toggleMask]="true"></p-password>
			</div>
			<div class="actions">
				<div class="button neutral" (click)="login()">Login</div>
			</div>
		</div>

		<div *ngIf="showTwoFactorStep">
			<div class="info-message">An authentication code has been sent to your email address. Please enter it below.</div>
			<div class="field">
				<label for="twoFactorCode">Authentication Code</label>
				<input pInputText type="text" [(ngModel)]="twoFactorCode" id="twoFactorCode" (keyup.enter)="verify2FA()" placeholder="Enter 6-digit code" />
			</div>
			<div class="actions">
				<div class="button neutral" (click)="verify2FA()">Verify</div>
				<div class="button secondary" (click)="goBack()">Back</div>
			</div>
		</div>
	</div>
</main>
